import React, { useEffect } from "react";
import { TextField } from "@mui/material";
import { setFieldValue } from "../MainContent/MainContentUtils";
import { useAppSelector } from "../../app/hooks";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { getDateExtern } from "../../app/utils/dateUtils";
import { showWarning } from "../../app/utils/validationUtils";

/* Functional component properties */
interface Props {
  classes: any;
  item: any;
  isGridElem: boolean;
  setWidth: string;
  clear: string;
  setClear: (clr: string) => void;
}

/* React Functional component */
export const Date: React.FC<Props> = ({
  /* Function arguments (Props) */
  classes,
  item,
  isGridElem,
  setWidth,
  clear,
  setClear,
}): JSX.Element => {
  /* get state */
  const state = useAppSelector((state) => state);

  const [val, setVal] = React.useState<string | number>(item.value);

  useEffect(() => {
    if (item.value !== val) {
      setVal(item.value);
    }
  }, [item]);

  useEffect(() => {
    // Set value in redux store mainContent.fieldList
    if (item.value !== val) {
      if (isGridElem) setFieldValue(item.field, val, item.id);
      else setFieldValue(item.name, val);
    }
  }, [val]);

  useEffect(() => {
    if (
      clear === "true" &&
      item.editable &&
      item.editable === "true" &&
      dayjs(val) !== dayjs("")
    ) {
      setClear("false");
      setVal("");
    } else if (clear === "true") {
      setClear("false");
    }
  });

  return isGridElem === true ? (
    item.colDef.canEdit && item.colDef.canEdit === true ? (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          {...(showWarning(item.field, item.id) ? { color: "error" } : {})} //Modified Fields
          key={item.field + item.id}
          inputFormat={state.appBar.loginInfo.data.dateformat}
          disableFuture
          label={item.label}
          openTo="year"
          views={["year", "month", "day"]}
          value={dayjs(val)}
          onChange={(newValue) => {
            if (item.field.substr(0, 1) !== "F") {
              window.myGlobalVar.pendingChanges.status = true; // Set pending changes
              if (
                window.myGlobalVar.pendingChanges.items.indexOf(
                  `${item.field + "(" + item.id + ")"}`
                ) === -1
              )
                window.myGlobalVar.pendingChanges.items.push(
                  `${item.field + "(" + item.id + ")"}`
                );
              window.myGlobalVar.pendingChanges.showWarning = false;
            }

            if (newValue !== null) setVal(newValue.format("YYYYMMDD"));
          }}
          renderInput={(params) => <TextField {...params} />}
        />
      </LocalizationProvider>
    ) : (
      <span>
        {getDateExtern(state.appBar.loginInfo.data.dateformat, item.value)}
      </span>
    )
  ) : (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        {...(showWarning(item.name) ? { color: "error" } : {})} //Modified Fields
        {...(item.editable && item.editable === "true"
          ? {}
          : { disabled: true })} //Disabled Fields
        className={
          item.visible && item.visible === "false" ? classes.hiddenField : "" //Hidden Fields
        }
        inputFormat={state.appBar.loginInfo.data.dateformat}
        disableFuture
        label={item.label}
        openTo="year"
        views={["year", "month", "day"]}
        value={dayjs(val)}
        onChange={(newValue) => {
          if (item.name.substr(0, 1) !== "F") {
            window.myGlobalVar.pendingChanges.status = true; // Set pending changes
            if (
              window.myGlobalVar.pendingChanges.items.indexOf(item.name) === -1
            )
              window.myGlobalVar.pendingChanges.items.push(item.name);
            window.myGlobalVar.pendingChanges.showWarning = false;
          }

          if (newValue !== null) setVal(newValue.format("YYYYMMDD"));
        }}
        renderInput={(params) => <TextField {...params} />}
      />
    </LocalizationProvider>
  );
};
